<template>
    <v-container>
        <div>
            <div style="background-color: rgb(230, 233, 242);">
                <v-img :src="require('../assets/rcp4.png')" max-width="100%" contain>
                    <v-row>
                        <v-col cols="12" md="6" lg="6">
                            <p style="font-size: 2rem; color: rgb(0, 30, 67);padding-left: 20px; margin-top: 20px;">
                                <b>UN Information Laboratory on Crime and Corruption for Latin America and the Caribbean (UN iLabCC)</b>
                            </p>                            
                        </v-col>
                    </v-row> 
                </v-img>
            </div>
            <!-- Descripción -->
            <v-spacer></v-spacer>
            <br>
            <v-card-text>
                <div>
            <h2>Our Audience</h2>
                    <p>
                        The UN Information Laboratory on Crime and Corruption for Latin America and the Caribbean - UN iLabCC is designed for the Resident Coordinators, 
                        their offices and UN Country Teams, members of the IBC on SDG 16, and staff from various agencies, programs, and funds that 
                        form the backbone of the <a href="https://www.rcplac.org/" target="_blank">RCP LAC</a>.
                    </p>
                </div>
            </v-card-text>
            <v-spacer></v-spacer>
        </div>
    </v-container>
</template>
<script>
export default {
    data() {
        return {
            card: {
                id: 0,
                title: '',
                subtitle: '',
                description: '',
                additionalInfo: '',
                images: [],
                chip: [],
            },
            showPdf: false,
        };  
    },
    methods: {        
        getImageSrc(filename) {
            return require(`../assets/${filename}`);
        },
        openPdf() {
            this.showPdf = true;
        },
    },
};
</script>
<style>
    p {
        font-family: 'Heebo', sans-serif;
        font-size: 17px;        
        line-height: 1.6em;
    }
    h1 {
        font-family: 'Heebo', sans-serif;
    }
    h2 {
        font-family: 'Heebo', sans-serif;
    }
    h3 {
        font-family: 'Heebo', sans-serif;
    }
    .p1 {
        font-family: 'Heebo', sans-serif;
        font-size: 14px;        
        line-height: 1.6em;
    }
</style>                    